import React, { useState, useEffect } from "react";
import * as FUNC from "../../functions/functions";
import * as API from '../../http/api';
import { FlexGrid, Typography, useThemeProvider, Card, useDialog } from "@albo-ui/core";
import { Box, IconButton, Tab, Tabs, Tooltip, Switch } from "@mui/material";
import { Visibility, KeyboardArrowDown, KeyboardArrowUp, ContactSupport} from "@mui/icons-material";
import { useHistory } from 'react-router-dom';
import DataTable from "react-data-table-component";
import { customStyles3 } from "../../util/TableStyles";
import { noDataComponent } from "../../util/DataObject"
import { paginationComponentOptions } from "../../util/i18n-es";
import Chargebacks from "../modals/chargebacks";
import { formatMoney } from "../../util/Functions";

import moment from "moment";
moment.locale('es');

const ChagerBack = (props) => {
    const history = useHistory();
	const dialogProps = useDialog()

    const { theme } = useThemeProvider();
    const [content, setContentProcess] = useState([]);
    const [contentDone, setContentDone] = useState([]);
    const [detailData, setDetailData] = useState(null);
    const [open, onSetOpen] = useState(false);
    const [tabActive, setTabActive] = useState("created");
    const [feature, setFeature] = useState({});

    const tabs = [
        { name: "created", title: "En proceso" },
        { name: "done", title: "Cerradas" },
    ];

    const status = [
        { key: "created", label: "En proceso" },
        { key: "done", label: "Cerrada" },
        { key: "funded", label: "Fondeada" },
    ];

    const detailProps = [
        {key: "folio", label: "Folio" },
        {key: "reason", label: "Aclaración" },
        {key: "amount", label: "Monto", type: "amount" },
        {key: "commerce", label: "Comercio" },
        {key: "cdate", label: "Fecha", type: "date" },
        {key: "detail_status", label: "Estatus", type: "status" },
        {key: "pdf_request", label: "Documento", type: "link" },
        {key: "customer_detail", label: "Detalle" },
        {key: "tx_uuid", label: "ID Transacción" },
        {key: "type", label: "Tipo de Aclaración", type: "type" },
    ];

    useEffect(() => {
        if (props.hasOwnProperty("config") && props.config.hasOwnProperty("fields") && props.config.hasOwnProperty("actions")) {
            dataWidget();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSearch = async () => {
        props.changeLoader(true);
        let data = {
            customer_uuid: props.item,
            page_number: 0,
            page_size: 10,
            sort: "desc"
        }

        let request = await API.service('chargebacksGet', data, props.pos, props.changeAlert, props.changeLoader, history);
        if(request.status === 200 && request.data.data.response === 'OK'){
            let result = request.data.data.content['chargeback'] || [];
            let resultDone = result.filter((item) => item.status === "done");
            let resultProcess = result.filter((item) => item.status === "created" || item.status === "funded");          
            setContentDone(resultDone);
            setContentProcess(resultProcess);
            onSetOpen(true)
        }
        props.changeLoader(false);
    }

    const validateClipFeature = async () => {
        props.changeLoader(true);

        let payload = {
            data: {
                customer_uuid: props.item,
                filters: [{
                    feature_name: "clip-feature",
                    uuid: "os.features.90fdebd9.6c08.4415.8af5.5607b8f8df97"
                }]
            }
        }

        let request = await API.service('featureCustomerGet', payload, props.pos, props.changeAlert, props.changeLoader, history);
        if(request.status === 200 && request.data.data.response === 'OK'){
            let result = (request.data.data.widget && request.data.data.widget[0]["data"]["content"]["features"]) || [];
            if(result.length > 0){
                setFeature(result[0])
            } else {
                setFeature(null)
            }
        }
        props.changeLoader(false);
    };

    const updateDomesticIn = async () => {
        props.changeLoader(true);

        let payload = {
            feature_uuid: "os.features.90fdebd9.6c08.4415.8af5.5607b8f8df97",
            customers: [props.item]
        }
        let service = ""
        feature ? service = "featureCustomerRemove" :  service = "featureCustomerAssign"

        let request = await API.service(service, payload, props.pos, props.changeAlert, props.changeLoader, history);
        if(request.status === 200 && request.data.data.response === 'OK'){
            props.changeAlert(true, 'success', 'El beneficio se actualizó con éxito');
            setFeature(null);
            validateClipFeature();
        }
        props.changeLoader(false);
    }

    const hasAction = (action) => {
        return props.config?.actions?.indexOf(action) > -1;
    };

    const onShowInfo  = () => {
		!open && hasAction("manageClipFeature") && validateClipFeature();
		!open && onSearch();
		open && onSetOpen(false);
	}

    const dataWidget = async () => {
        let x = await FUNC.filter(props.data, props.config.fields.in);
        x = await FUNC.exclude(x, props.config.fields.ex);
        setContentProcess(JSON.parse(JSON.stringify(x)));
    };
    const changeTab = (tab: string) => {
        setTabActive(tab);
    };
    function findActiveTab(item) { 
        return item.name === tabActive;
    };
    const onOpenDialog = async (data) => {
		dialogProps.openDialog()
        setDetailData(data)
	}
	const onCloseDialog = () => {
        dialogProps.onClose()
        setDetailData(null)
	}

    const columns = [
        { selector: (row) => status.filter((item) => row.status === item.key)[0]?.label || "N/A", name: 'Estado', wrap: true, sortable: true },
        { selector: (row) => row.reason, name: "Aclaración", wrap: true, sortable: false },
        { selector: (row) => row.folio || "N/A", name: "Folio", sortable: false },
        { selector: (row) => formatMoney(row.amount, true), name: "Monto", sortable: false },
        { selector: (row) => moment(row.udate).format("L"), name: "Fecha", width: "7rem", sortable: false },
        { selector: (row) => row.commerce, name: "Comercio", wrap: true, sortable: false },
        { cell: (row) => {
            return <Tooltip title="Ver detalle">
                <IconButton onClick={onOpenDialog.bind(this, row)}>
                    <Visibility color="primary" />
                </IconButton>
            </Tooltip>
          },
          sortable: true, wrap: true, width: "60px"
        },
    ]

    return (
        <div className="size-6 dataBlock">
            <Card
                padding={2} fullWidth flexDirection="column" alignItems="stretch" justifyContent="space-between"
                style={{ borderColor: theme.colors.manatee, height: "auto" }}
            >
                <FlexGrid container item direction="column" spacing={1}>
                    <FlexGrid item style={{paddingBottom: "0.8rem"}}>
                        <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                            <ContactSupport sx={{mr: 2}}/> Aclaraciones
                        </Typography>
                        {open ?
                            <KeyboardArrowUp sx={{ float: "right", cursor: "pointer"}} onClick={onShowInfo}/>
                            :							
                            <KeyboardArrowDown sx={{ float: "right", cursor: "pointer"}} onClick={onShowInfo}/>
                        }
                    </FlexGrid>

                    {open && 
                        <>
                            {hasAction("manageClipFeature") && 
                                <Box>
                                    <Tooltip title={(feature && feature["feature_name"] === "clip-feature") ? "Desactivar" : "Activar"}>
                                        <Switch checked={(feature && feature["feature_name"] === "clip-feature") || false} onClick={updateDomesticIn.bind(this)}  />
                                    </Tooltip>
                                    Link de Pagos Domésticos
                                </Box>
                            }
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} mb={2} >
                                <Tabs value={tabs.findIndex(findActiveTab)} indicatorColor='secondary' textColor='secondary' variant="fullWidth" centered>
                                    {tabs.map((item, index) => {
                                        return <Tab key={index} label={item.title} onClick={changeTab.bind(this, item.name)} sx={{textTransform: 'none', fontWeight: 700, fontFamily: "Muli,sans-serif", fontSize: 18}} />
                                    })}
                                </Tabs>
                            </Box>
                            {
                                tabActive === "done" && 
                                <FlexGrid container spacing={2} style={{margin: '25px 0' }}>
                                    <DataTable
                                        columns={columns}
                                        data={contentDone}
                                        customStyles={customStyles3}
                                        noDataComponent={noDataComponent}
                                        paginationComponentOptions={paginationComponentOptions}
                                    />
                                </FlexGrid>
                            }
                            {
                                tabActive === "created" && 
                                <FlexGrid container spacing={2} style={{margin: '25px 0' }}>
                                    <DataTable
                                        columns={columns}
                                        data={content}
                                        customStyles={customStyles3}
                                        noDataComponent={noDataComponent}
                                        paginationComponentOptions={paginationComponentOptions}
                                    />
                                </FlexGrid>
                            }
                        </>
                    }
                </FlexGrid>
            </Card>
            <Chargebacks 
                title={"Detalle de la aclaración"} 
                open={dialogProps.open} 
                onClose={onCloseDialog} 
                data={detailData}
                props={detailProps}
            />
		</div>
    );
};

export default ChagerBack;
